import React, { useState, useEffect } from 'react';
import { useGameContext } from '../GameContext';

const ScrambledSentence: React.FC = () => {
  const { 
    scrambledWords, 
    originalWords, 
    solvedIndices, 
    reshuffleWord 
  } = useGameContext();
  const [recentlySolved, setRecentlySolved] = useState<number[]>([]);
  const [prevSolvedCount, setPrevSolvedCount] = useState(0);
  const [recentlyShuffled, setRecentlyShuffled] = useState<number[]>([]);

  // Detect newly solved words and animate them
  useEffect(() => {
    if (solvedIndices.length > prevSolvedCount) {
      // Get the most recently solved word index
      const newSolved = solvedIndices[solvedIndices.length - 1];
      setRecentlySolved(prev => [...prev, newSolved]);
      
      // Remove from recently solved after animation completes
      setTimeout(() => {
        setRecentlySolved(prev => prev.filter(idx => idx !== newSolved));
      }, 1000); // Animation duration
    }
    
    setPrevSolvedCount(solvedIndices.length);
  }, [solvedIndices, prevSolvedCount]);
  
  // Handler for shuffling a specific word
  const handleWordClick = (index: number) => {
    // Skip if the word is already solved
    if (solvedIndices.includes(index)) return;
    
    // Reshuffle the word
    reshuffleWord(index);
    
    // Add to recently shuffled for animation
    setRecentlyShuffled(prev => [...prev, index]);
    
    // Remove from recently shuffled after animation completes
    setTimeout(() => {
      setRecentlyShuffled(prev => prev.filter(idx => idx !== index));
    }, 500); // Animation duration
    
    // Restore focus to the input field after shuffling a word
    const inputElement = document.querySelector('input[type="text"]') as HTMLInputElement;
    if (inputElement) {
      setTimeout(() => {
        inputElement.focus();
      }, 100);
    }
  };

  if (scrambledWords.length === 0) {
    return <div className="scrambled-sentence-placeholder">Scrambled sentence will appear here</div>;
  }

  return (
    <div className="scrambled-sentence-container">
      <div className="scrambled-sentence">
        {scrambledWords.map((word: string, index: number) => {
          const isSolved = solvedIndices.includes(index);
          const isJustSolved = recentlySolved.includes(index);
          const isJustShuffled = recentlyShuffled.includes(index);
          
          return (
            <span
              key={index}
              className={`
                scrambled-word 
                ${isSolved ? 'solved' : 'unsolved'} 
                ${isJustSolved ? 'just-solved' : ''} 
                ${isJustShuffled ? 'just-shuffled' : ''}
              `}
              onClick={() => !isSolved && handleWordClick(index)}
              title={!isSolved ? "Click to shuffle this word" : ""}
            >
              {isSolved ? originalWords[index] : word}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ScrambledSentence;
